if (!customElements.get('product-addons')) {
  customElements.define('product-addons', class ProductAddons extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.productInfo = this.closest('product-info');
        this.form = document.getElementById(this.dataset.formId);
        this.cards = [...this.querySelectorAll('[data-addon-card]')];
        this.available = this.dataset.available === 'true' && !!this.form;
        const options = { signal: this.abortController.signal };
        this.productInfo.addEventListener('change', () => this.update(), options);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;
          this.available = !!data.variant?.available && !!this.form;
          this.update();
        });
        this.update();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.unsubscribe?.();
    }

    get quantity() {
      return Math.max(1, Number(this.form?.elements.namedItem('quantity')?.value) || 1);
    }

    get selectedItems() {
      return (this.cards || []).flatMap(card => {
        const toggle = card.querySelector('[data-addon-toggle]');
        return toggle.checked && toggle.dataset.available === 'true' && this.available
          ? [{ id: toggle.dataset.variantId, quantity: card.dataset.quantityMode === 'per_item' ? this.quantity : 1 }]
          : [];
      });
    }

    update() {
      for (const card of this.cards) {
        const toggle = card.querySelector('[data-addon-toggle]');
        const select = card.querySelector('[data-addon-variant]');
        const price = card.querySelector('[data-addon-price]');
        if (select) {
          const option = select.selectedOptions[0];
          toggle.dataset.variantId = option.value;
          toggle.dataset.available = option.dataset.available;
          price.dataset.unitPrice = option.dataset.price;
          select.disabled = this.busy || !this.available;
        }
        const available = toggle.dataset.available === 'true';
        if (!available || !this.available) toggle.checked = false;
        toggle.disabled = this.busy || !available || !this.available;
        card.querySelector('[data-addon-stock]').hidden = available;
        const quantity = card.dataset.quantityMode === 'per_item' ? this.quantity : 1;
        price.textContent = `+ ${quantity > 1 ? `${quantity} × ` : ''}${price.dataset.unitPrice}`;
      }
      const selected = this.selectedItems.length;
      const paymentForm = this.productInfo.querySelector('[data-type="payment-button-form"]');
      const checkout = this.productInfo.querySelector('[data-addon-checkout]');
      if (paymentForm && checkout) {
        paymentForm.hidden = selected > 0;
        checkout.hidden = !selected;
        checkout.disabled = this.busy || !this.available;
      }
      this.querySelector('[role="status"]').textContent = selected
        ? `${selected} add-on${selected === 1 ? '' : 's'} selected. Included when you add to cart or checkout with add-ons.`
        : 'No add-ons selected.';
    }

    // Keep line-item properties (including files), selling plans, and section
    // rendering fields when changing a single-item form to Shopify's items array.
    prepareFormData(formData) {
      const items = this.selectedItems;
      if (!items.length) return false;
      for (const [key, value] of [...formData.entries()]) {
        if (['id', 'quantity', 'selling_plan'].includes(key)) {
          formData.append(`items[0][${key}]`, value);
          formData.delete(key);
        } else if (key.startsWith('properties[') && key.endsWith(']')) {
          formData.append(`items[0][properties][${key.slice(11, -1)}]`, value);
          formData.delete(key);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', '1');
      items.forEach((item, index) => {
        formData.append(`items[${index + 1}][id]`, item.id);
        formData.append(`items[${index + 1}][quantity]`, String(item.quantity));
      });
      return true;
    }

    setBusy(busy) {
      this.busy = busy;
      this.update();
    }

    showError(message = '') {
      const error = this.querySelector('.product-addons__error');
      error.hidden = !message;
      error.querySelector('span').textContent = message;
    }
  });
}
